import InitializationError from '../exceptions/InitializationError';
import scrollToTarget from './scrollToTarget';
const handleElementClick = (element, target) => {
    const offset = parseInt(element.getAttribute('data-scroll-to-target-offset') ?? '0', 10);
    const hasHeaderOffset = element.getAttribute('data-scroll-to-target-header-offset') === 'true';
    scrollToTarget(target, offset, hasHeaderOffset);
};
export const handleScrollToTargetElements = () => {
    const scrollToTargetElements = Array.from(document.querySelectorAll('[data-scroll-to-target-selector]'));
    for (const element of scrollToTargetElements) {
        const targetSelector = element.getAttribute('data-scroll-to-target-selector');
        if (!targetSelector) {
            throw new InitializationError({ targetSelector: 'Missing target selector.' });
        }
        const target = document.querySelector(targetSelector);
        if (!target) {
            throw new InitializationError({ target: 'Target not found.' });
        }
        element.addEventListener('click', () => handleElementClick(element, target));
    }
};
